module.exports = "/assets/data/74b59f1ea48693b5903bd11ce2b8396d-NE35.data.json";